import { store } from "redux/store"
import { FHIRSearch } from "./http"
import { toast } from "react-toastify"
import i18n from "multilingual"

const data = store.getState()

export const GET_PERSON_FROM_UID = async (uid) => {
    try {
        let res = await FHIRSearch(`Person`, `identifier=${uid}`)
        if (res?.data?.total > 0) {
            return res.data.entry[0]
        } else {
            toast.info(i18n.t('common.PERSON_DATA_NOT_FOUND'))
        }
    } catch (err) {
        toast.error(i18n.t('common.ERROR'))
    }
}